/**
 * OAuth helpers for AuthFlow.
 *
 * iOS Safari (including iPadOS desktop UA) cannot reliably complete
 * signInWithPopup — the Google/Apple sheet succeeds, then the opener loses
 * the session and the user lands back on /auth. Use redirect on those devices.
 */

import { isLikelyIosDevice } from 'utils/isLikelyIosDevice';

export const OAUTH_REDIRECT_PENDING_KEY = 'fusionmsi.oauthRedirectPending';
export const AUTH_NEXT_PATH_KEY = 'fusionmsi.authNextPath';

export { isLikelyIosDevice };

export function shouldUseOAuthRedirect() {
  return isLikelyIosDevice();
}

function storageSet(key, value) {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // Private mode / quota.
  }
}

function storageGet(key) {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function storageRemove(key) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
}

export function markOAuthRedirectPending() {
  storageSet(OAUTH_REDIRECT_PENDING_KEY, '1');
}

export function clearOAuthRedirectPending() {
  storageRemove(OAUTH_REDIRECT_PENDING_KEY);
}

export function isOAuthRedirectPending() {
  return storageGet(OAUTH_REDIRECT_PENDING_KEY) === '1';
}

export function stashAuthNextPath(path) {
  if (typeof path === 'string' && path.startsWith('/') && !path.startsWith('//')) {
    storageSet(AUTH_NEXT_PATH_KEY, path);
    return;
  }
  storageRemove(AUTH_NEXT_PATH_KEY);
}

export function peekStashedAuthNextPath() {
  return storageGet(AUTH_NEXT_PATH_KEY);
}

export function clearStashedAuthNextPath() {
  storageRemove(AUTH_NEXT_PATH_KEY);
}
